module.exports = __webpack_public_path__ + "img/aduana-1.bc1030d5.svg";